export const SIDE_MENU_FILTER_MENU_MODES = Object.freeze({
  FILTERS: "filters",
  WEEKDAYS: "weekdays",
});

const SIDE_MENU_FILTERS_REQUIRING_WEEKDAY = new Set([
  "EmpiezaSemana",
  "TerminaSemana",
]);

export const doesSideMenuFilterRequireWeekdaySelection = (condition) =>
  SIDE_MENU_FILTERS_REQUIRING_WEEKDAY.has(condition);

export const shouldApplySideMenuFilterImmediately = (condition) =>
  !doesSideMenuFilterRequireWeekdaySelection(condition);

export const resolveSideMenuFilterMenuCloseTransition = ({
  mode,
  hasPendingWeekdayReopen,
} = {}) => {
  if (hasPendingWeekdayReopen) {
    return {
      nextMode: SIDE_MENU_FILTER_MENU_MODES.WEEKDAYS,
      shouldReopen: true,
    };
  }

  if (mode === SIDE_MENU_FILTER_MENU_MODES.WEEKDAYS) {
    return {
      nextMode: SIDE_MENU_FILTER_MENU_MODES.FILTERS,
      shouldReopen: false,
    };
  }

  return {
    nextMode: SIDE_MENU_FILTER_MENU_MODES.FILTERS,
    shouldReopen: false,
  };
};
